import ScrollBooster from 'scrollbooster';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
export default function () {
  const swiper = new Swiper(".swiper", {
    loop: false,
    grabCursor: true,
    paginationClickable: true,
    spaceBetween: 30,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });


    $(function(){
      $('.titles .title-unit').each(function(i){
        $(this).attr('class','title-unit num' + (i+1));
      });
    });

}
